import { ClinicalDatasetReadDto } from "functions/api/library/interface";
import { AnnotationVariable } from "../ars";

/**
 * Maps a ClinicalDatasetReadDto to an array of AnnotatedVariable.
 *
 * @param dataset - The clinical dataset to map.
 * @returns An array of AnnotatedVariable objects.
 */
export function datasetToAnnotatedVariables(dataset: ClinicalDatasetReadDto): AnnotationVariable[] {
  return dataset.clinicalVariables.map((variable) => ({
    value: `${dataset.name.trim()}.${variable.name.trim()}`,
    oid: variable.oid,
    name: variable.name,
    dataType: variable.dataType,
    length: parseInt(variable.length ?? "8", 10),
    dataset: dataset.name,
  }));
}
